var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupervisedUserCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "supervised_user_circle",
    clipPath: "url(#clip0_307_14916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.88531C6.48 2.88531 2 7.36531 2 12.8853C2 18.4053 6.48 22.8853 12 22.8853C17.52 22.8853 22 18.4053 22 12.8853C22 7.36531 17.52 2.88531 12 2.88531ZM15.61 9.22532C16.68 9.22532 17.54 10.0853 17.54 11.1553C17.54 12.2253 16.68 13.0853 15.61 13.0853C14.54 13.0853 13.68 12.2253 13.68 11.1553C13.67 10.0853 14.54 9.22532 15.61 9.22532ZM9.61 7.64532C10.91 7.64532 11.97 8.70531 11.97 10.0053C11.97 11.3053 10.91 12.3653 9.61 12.3653C8.31 12.3653 7.25 11.3053 7.25 10.0053C7.25 8.69531 8.3 7.64532 9.61 7.64532ZM9.61 16.7753V20.5253C7.21 19.7753 5.31 17.9253 4.47 15.5653C5.52 14.4453 8.14 13.8753 9.61 13.8753C10.14 13.8753 10.81 13.9553 11.51 14.0953C9.87 14.9653 9.61 16.1153 9.61 16.7753ZM12 20.8853C11.73 20.8853 11.47 20.8753 11.21 20.8453V16.7753C11.21 15.3553 14.15 14.6453 15.61 14.6453C16.68 14.6453 18.53 15.0353 19.45 15.7953C18.28 18.7653 15.39 20.8853 12 20.8853Z",
    fill: "#123051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_14916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.885315)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedUserCircle);
export default __webpack_public_path__ + "static/media/supervised_user_circle.c1021abaf6e7075c8249382dd0b800b5.svg";
export { ForwardRef as ReactComponent };